import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  fetchSubscriptionById as fetchSubscriptionByIdApi,
  fetchSubscriptionHistory as fetchSubscriptionHistoryApi,
} from "@/helpers/apis";
import { QUERY_OPTIONS } from "@/pages/subscriptions/services/queryConfig";

export type {
  SubscriptionHistoryItem,
  SubscriptionHistoryResponse,
} from "@/pages/subscriptions/services/types";

// Zod validation is handled by api.get in apis.ts (via patchWithZodSchema)
export const useSubscriptionById = (subscriptionId?: string) => {
  return useQuery({
    queryKey: ["subscription-v2", subscriptionId],
    queryFn: () => fetchSubscriptionByIdApi(subscriptionId!),
    enabled: !!subscriptionId,
    ...QUERY_OPTIONS.detail,
  });
};

export const useSubscriptionHistory = (
  subscriptionId?: string,
  page: number = 1,
  size: number = 10,
  status?: string,
  startDate?: string,
  endDate?: string
) => {
  return useQuery({
    queryKey: ["subscription-history", subscriptionId, page, size, status, startDate, endDate],
    queryFn: () =>
      fetchSubscriptionHistoryApi(subscriptionId!, {
        page,
        size,
        ...(status && { status }),
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
      }),
    enabled: !!subscriptionId,
    ...QUERY_OPTIONS.detail,
    placeholderData: keepPreviousData,
  });
};
